// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mandatory[data-v-e4f69796] {
  white-space: nowrap;
}
.mandatory[data-v-e4f69796]::after {
  content: " *";
}
.mandatory--enabled[data-v-e4f69796]::after {
  color: rgb(219, 52, 52);
}
.mandatory--disabled[data-v-e4f69796]::after {
  color: #666;
}
.formfield-decorator__flex[data-v-e4f69796] {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
}
.formfield-decorator__flex .vl-form__label[data-v-e4f69796] {
  padding-right: 10px;
  white-space: nowrap;
}
.formfield-decorator__flex > div[data-v-e4f69796] {
  display: flex;
  align-items: center;
}
.over-limit[data-v-e4f69796] {
  color: #d53e5e !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
